import React from 'react';
import { ListItemProps } from 'app/area/experience-transfer/operations/types-store';
import { createOperationsList } from 'app/area/experience-transfer/operations/create-operations-list';
import { ListItemCheckbox } from 'app/area/experience-transfer/operations/components/list-item-checkbox';
import styles from './list-item.scss';

export const ListItem: React.FC<ListItemProps> = ({
  item, listItems, updating, translation, updateOperations
}) => {

  const onChange = () => {
    updateOperations(item.id, createOperationsList(item.id, listItems), translation.operations_updated);
  };

  return <div className={styles.operationsRow}>
    <div className={`${styles.container} ${updating ? styles.disabled : ''}`}>
      <div className={styles.content}>
        <div className={styles.leftSide}>
          <div className={styles.leftSideColumn}>
            <div className={styles.defaultColumn}>
              <ListItemCheckbox
                id={item.id}
                checked={item.active}
                disabled={updating}
                onChange={onChange} />
              <span>{item.description}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>;
};
